import createZaloTaskZNS from './ZaloTaskZNS';
import { ZaloTaskZNSRoutes } from './routes';
import createEditZNS from './Edit/Edit';

export const createZaloTaskZNSPage = () => {
  const ZaloTaskZNS = createZaloTaskZNS();
  const EditPage = createEditZNS();

  return () => <ZaloTaskZNSRoutes ZaloTask={ZaloTaskZNS} Edit={EditPage}></ZaloTaskZNSRoutes>;
};
